import type { Chart as ChartJS } from 'chart.js';

export const chartIndexCrosshairPlugin = {
  id: 'chartIndexCrosshair',
  afterDraw(chart: ChartJS) {
    const tooltip = chart.tooltip;
    if (!tooltip || tooltip.opacity === 0) return;

    const x = tooltip.caretX;
    const { top, bottom } = chart.chartArea;
    const ctx = chart.ctx;
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(x, top);
    ctx.lineTo(x, bottom);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.25)';
    ctx.stroke();
    ctx.restore();
  },
};
